"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardService = void 0;
const api_1 = require("./api");
const PATH_V1 = '/reward/api/v1';
const PATH_V2 = '/reward/api/v2';
class RewardService {
    static async getRewardList(deviceType) {
        try {
            const requestParams = deviceType;
            const response = await api_1.API.get({
                url: `${PATH_V1}/rewards?deviceType=${requestParams}`
            });
            return response;
        }
        catch (e) {
            throw e;
        }
    }
    static async getRewards(mobileOnly, featured, type, state) {
        const requestParams = [];
        requestParams.push(`sort=order,asc`);
        requestParams.push(`sort=createdDate,desc`);
        if (type) {
            requestParams.push(`type.equals=${type}`);
        }
        if (mobileOnly) {
            requestParams.push(`visibilityMobile.equals=true`);
        }
        else {
            requestParams.push(`visibilityWeb.equals=true`);
        }
        requestParams.push(`featured.equals=${featured}`);
        if (state)
            requestParams.push(`rewardState.equals=${state}`);
        const url = `${PATH_V2}/rewards?${requestParams.join('&')}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async getUserRewards(mobileOnly, featured, type) {
        const requestParams = [];
        requestParams.push('sort=featured,desc');
        requestParams.push('sort=order,asc');
        requestParams.push('sort=createdDate,desc');
        requestParams.push(`webOnly=${!mobileOnly}`);
        requestParams.push(`featured=${Boolean(featured)}`);
        if (type) {
            requestParams.push(`type=${type}`);
        }
        const url = `${PATH_V2}/user/rewards?${requestParams.join('&')}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async fetchRewardDetails(id) {
        const url = `${PATH_V1}/rewards/${id}`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async redeemReward(id, quantity) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/rewards/${id}/redeem`,
                body: { quantity }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async redeemRewardV2(id, quantity) {
        try {
            return await api_1.API.post({
                url: `${PATH_V2}/rewards/${id}/redeem`,
                body: { quantity }
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async getRewardWithFrequencyCap(id) {
        const url = `${PATH_V1}/rewards/${id}/player`;
        try {
            return await api_1.API.get({ url });
        }
        catch (error) {
            throw error;
        }
    }
    static async claimFreeEntry(id, recaptcha) {
        try {
            return await api_1.API.post({
                url: `${PATH_V1}/rewards/${id}/redeem/free`,
                body: { quantity: 1, recaptcha }
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.RewardService = RewardService;
//# sourceMappingURL=reward-service.js.map